export default ({ COLORS }) => ({
  left: {
    textAlign: 'left'
  },
  date: {
    textAlign: 'left',
    width: '120px'
  },
  all: {
    width: '60px'
  },
  conclusion: {
    width: '120px'
  },
  contributors: {
    width: '140px'
  },
  contextMenuCell: {
    width: '60px'
  }
})
